import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'

import routes from './routes'

/**
 * Represents the function to create a history object for routing.
 * The type of history object created depends on the environment variables.
 *
 * @returns {object} The history object for routing.
 */
const createHistory = process.env.SERVER
  ? createMemoryHistory
  : createWebHistory /* DISCLAIMER: Because of our tapestry filter chain, we must use web history, as the hash mode does not send the part after the # to the server ( https://router.vuejs.org/guide/essentials/history-mode.html#Hash-Mode ) */

/**
 * Create a router instance with specified options.
 *
 * @param {object} options - The router configuration options.
 * @param {function} options.scrollBehavior - A function that returns the scroll position.
 * @param {array} options.routes - An array of route configurations.
 * @param {object} options.history - The router history object.
 * @returns {object} - The created router instance.
 */
const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(process.env.VUE_ROUTER_BASE),
})

export default router
